import { authorizedApi } from '@/services/network/authorized-api';

export const approveMembership = (id: number) => authorizedApi.put(`/v1/memberships/${id}/accept`);

export const rejectMembership = (id: number, reason: string) =>
  authorizedApi.put(`/v1/memberships/${id}/decline`, { reason });
